import { render } from "./btn-social-share.vue?vue&type=template&id=624d17bb"
import script from "./btn-social-share.vue?vue&type=script&lang=js"
export * from "./btn-social-share.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__